import * as React from "react";
import styled from "styled-components";

import {
  AVAILABLE_COUNTRIES,
  AVAILABLE_LANGS,
  ORIGIN,
  WHATS_INCLUDED_TYPE,
} from "@typings/globals";

import { SkeletonGenerator } from "@ui/Atoms";
import { WhatsIncludedContent } from "@ui/Molecules/WhatsIncludedContent";

import { usePrismic } from "@hooks/usePrismic";

interface Props {
  country: AVAILABLE_COUNTRIES;
  language: AVAILABLE_LANGS;
}

const WarrantyModalContent = (props: Props): React.ReactElement => {
  const { getPrismicEntry, isApiReady } = usePrismic();
  const [content, setContent] = React.useState<null | { [k: string]: any }>(
    null,
  );

  React.useEffect(() => {
    if (!isApiReady) {
      return;
    }

    (async () => {
      const response = await getPrismicEntry({
        contentType: "whats_included_modal",
        origin: ORIGIN.BATMAID,
        lang: props.language,
        country: props.country,
      });

      if (response?.length) {
        setContent(response[0]?.data);
      }
    })();
  }, [props.language, isApiReady]);

  return (
    <StyledIncluded>
      {content ? (
        <WhatsIncludedContent
          data={content[WHATS_INCLUDED_TYPE.EOT_WARRANTY]}
          isEOT
        />
      ) : (
        <SkeletonGenerator count={10} randomWidth={80} />
      )}
    </StyledIncluded>
  );
};

WarrantyModalContent.displayName = "WarrantyModalContent";

export { WarrantyModalContent };

const StyledIncluded = styled.div`
  h2 {
    margin-bottom: ${props => props.theme.margins.base_x2};
    font-size: ${props => props.theme.fonts.sizes.body2};
  }

  p,
  ul,
  div {
    color: ${props => props.theme.palette.grey600};
    font-size: ${props => props.theme.fonts.sizes.caption};
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      margin-bottom: ${props => props.theme.margins.base};
      position: relative;
      padding-left: ${props => props.theme.margins.base_x2};

      &:before {
        color: ${props => props.theme.palette.green500};
        content: "✓";
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
`;
